<template>
  <div @mousemove="handleMouseMove" @mouseup="handleMouseUp">
    <div style="margin-bottom: 10px" class="df both-side">
      <a-space>
        <div>{{ route.query.projectName }}</div>
        <a-select
          :options="projectLifeCycleOptions"
          v-model:value="requestPayload.projectLifeCycle"
          allowClear
          style="width: 200px"
          placeholder="项目阶段"
          @change="hanndleSearch"
        ></a-select>

        <a-input
          placeholder="任务名称"
          v-model:value="searchInput"
          allowClear
          @change="hanndleSearch"
        ></a-input>

        <!-- <a-select
          placeholder="部门"
          @change="hanndleSearch"
          v-model:value="requestPayload.structureName"
          allowClear
          style="width: 100px"
        >
          <a-select-option value="光学部">光学部</a-select-option>
          <a-select-option value="结构部">结构部</a-select-option>
          <a-select-option value="电子部">电子部</a-select-option>
          <a-select-option value="算法部">算法部</a-select-option>
          <a-select-option value="嵌软组">嵌软组</a-select-option>
          <a-select-option value="云端组">云端组</a-select-option>
        </a-select> -->
        <a-select
          v-model:value="requestPayload.publisher"
          show-search
          placeholder="发布人"
          style="width: 200px"
          :options="staffList"
          @change="hanndleSearch"
          allowClear
        >
        </a-select>

        <a-select
          v-model:value="requestPayload.executor"
          show-search
          placeholder="执行人"
          style="width: 200px"
          :options="staffList"
          @change="hanndleSearch"
          allowClear
        >
        </a-select>

        <a-tooltip placement="top">
          <template #title>
            <span> {{ !ganttShow ? "展示甘特图" : "关闭甘特图" }}</span>
          </template>
          <img
            v-if="!ganttShow"
            src="@/assets/img/page/gantt_hide.png"
            class="gantt-show-config"
            @click="handleUpdateGanttShow"
          />
          <img
            v-else
            src="@/assets/img/page/gantt_show.png"
            class="gantt-show-config"
            @click="handleUpdateGanttShow"
          />
        </a-tooltip>
      </a-space>
      <a-button
        type="primary"
        @click="handleUpdateRecord(null, 'insertTask')"
        :disabled="!isProjectLear && user.id !== 5"
        >新增</a-button
      >
    </div>

    <div class="df both-side scheme-table">
      <a-table
        :data-source="showTable"
        bordered
        :pagination="false"
        :columns="columns"
        :indentSize="20"
        :style="ganttShow ? tableLayout : ''"
        :rowClassName="
          (record, index) =>
            !record.isOpen
              ? 'table-disabled special-row'
              : index % 2 === 0
              ? 'special-row even-row'
              : 'special-row odd-row'
        "
        rowKey="id"
        v-if="table.data.length > 0"
        :scroll="{
          x: 'calc(100vw - 80px)',
          y: 'calc(100vh - 210px)',
        }"
        :expandedRowKeys="expandedRowKeys"
        @expand="expand"
      >
        <template
          #filterDropdown="{
            setSelectedKeys,
            selectedKeys,
            confirm,
            clearFilters,
            column,
          }"
        >
          <div style="padding: 8px">
            <a-input
              ref="handleSearchInput"
              :placeholder="`搜索`"
              :value="selectedKeys[0]"
              style="width: 188px; margin-bottom: 8px; display: block"
              @change="
                (e) => setSelectedKeys(e.target.value ? [e.target.value] : [])
              "
              @pressEnter="
                handleSearch(selectedKeys, confirm, column.dataIndex)
              "
            />
            <a-button
              type="primary"
              size="small"
              style="width: 90px; margin-right: 8px"
              @click="handleSearch(selectedKeys, confirm, column.dataIndex)"
            >
              <template #icon><SearchOutlined /></template>
              搜索
            </a-button>
            <a-button
              size="small"
              style="width: 90px"
              @click="handleReset(clearFilters)"
            >
              重置
            </a-button>
          </div>
        </template>
        <template #outputResults="{ record }">
          <div
            class="task-result"
            @click="showTextDetail(record, 'outputResults', false)"
          >
            <template v-if="record.outputResults">
              <div
                v-for="(item, index) in JSON.parse(record.outputResults)"
                :key="index"
                class="outupt-result-text-left"
              >
                {{ index + 1 }}、{{ item.value }}
              </div>
            </template>
          </div>
        </template>

        <template #startDate="{ record }">
          <div
            class="output-result"
            :class="record.isOpen ? 'publish-pale' : ''"
          >
            {{ record.releaseStartTime }}
          </div>
          <div
            class="output-result"
            :class="record.isOpen ? 'excutor-pale' : ''"
          >
            {{ record.scheduledStartTime }}
          </div>
          <div
            class="output-result"
            :class="record.isOpen ? 'excutor-pale' : ''"
          >
            {{ record.actualReleaseStartTime }}
          </div>
        </template>

        <template #endDate="{ record }">
          <div
            class="output-result"
            :class="record.isOpen ? 'publish-pale' : ''"
          >
            {{ record.releaseEndTime }}
          </div>
          <div
            class="output-result"
            :class="record.isOpen ? 'excutor-pale' : ''"
          >
            {{ record.scheduledEndTime }}
          </div>
          <div
            class="output-result"
            :class="record.isOpen ? 'excutor-pale' : ''"
          >
            {{ record.actualReleaseEndTime }}
          </div>
        </template>

        <template #execute="{ record }">
          <div
            class="output-result"
            :class="record.isOpen ? 'publish-pale' : ''"
          >
            <a-button
              size="small"
              type="primary"
              :disabled="record.publisher !== user.nickName"
              @click="handleUpdateRecord(record, 'release')"
              >发布</a-button
            >
          </div>
          <div
            class="output-result"
            :class="record.isOpen ? 'excutor-pale' : ''"
          >
            <a-button
              size="small"
              :disabled="record.executor !== user.nickName && !isProjectLear"
              @click="handleUpdateRecord(record, 'scheduled')"
              >计划</a-button
            >
          </div>
          <div
            class="output-result"
            :class="record.isOpen ? 'excutor-pale' : ''"
          >
            <a-button
              size="small"
              danger
              :disabled="record.executor !== user.nickName && !isProjectLear"
              @click="handleUpdateRecord(record, 'actualRelease')"
            >
              实际
            </a-button>
          </div>
        </template>

        <template #workRecords="{ record }">
          <!-- <div class="task-result">
            {{ record.workRecords }}
          </div> -->
          <div
            class="task-result"
            @click="showTextDetail(record, 'workRecords', false)"
          >
            <template
              v-if="
                record.workRecords && record.workRecords.indexOf('[') !== -1
              "
            >
              <div
                v-for="(item, index) in JSON.parse(
                  record.workRecords
                ).reverse()"
                :key="index"
                class="outupt-result-text-left"
              >
                {{ JSON.parse(record.workRecords).length - index }}
                、{{ item.value }}
              </div>
            </template>
          </div>
        </template>
        <template #assistanceNeeded="{ record }">
          <div class="task-result">
            {{ record.assistanceNeeded }}
          </div>
        </template>

        <template #completionDegree="{ record }">
          <div v-if="record.completionDegree">
            {{ record.completionDegree }}%
          </div>
        </template>

        <template #action="{ record }">
          <a-space :size="10">
            <!-- <a-button
            size="small"
            @click="handleUpdateRecord(record, 'insertSubtask')"
            type="primary"
          >
            添加子任务
          </a-button> -->

            <a-tooltip
              placement="top"
              v-if="record.executor === user.nickName || isProjectLear"
            >
              <template #title>
                <span>添加子任务</span>
              </template>
              <PlusSquareOutlined
                class="action-icon"
                @click="handleUpdateRecord(record, 'insertSubtask')"
              />
            </a-tooltip>
            <!-- <a-button
            size="small"
            @click="handleUpdateRecord(record, 'updateTask')"
            >编辑</a-button
          > -->
            <a-tooltip
              placement="top"
              v-if="record.publisher === user.nickName"
            >
              <template #title>
                <span>编辑</span>
              </template>
              <EditOutlined
                class="action-icon"
                @click="handleUpdateRecord(record, 'updateTask')"
              />
            </a-tooltip>
            <!-- <a-button
            size="small"
            type="danger"
            @click="handleDeleteRecord(record)"
            >删除</a-button
          > -->

            <a-tooltip
              placement="top"
              v-if="record.publisher === user.nickName"
            >
              <template #title>
                <span>删除</span>
              </template>
              <DeleteOutlined
                class="action-icon danger"
                @click="handleDeleteRecord(record)"
              />
            </a-tooltip>
          </a-space>
        </template>
      </a-table>

      <template v-if="ganttShow">
        <slider-gannt @updateLayout="updateLayout"></slider-gannt>

        <custom-gannt
          :ganntConfig="ganntConfig"
          :style="ganttLayout"
        ></custom-gannt>
      </template>
    </div>

    <project-scheme-form
      ref="projectSchemeFormRef"
      @updateTable="getData"
      :projectLifeCycle="requestPayload.projectLifeCycle"
    ></project-scheme-form>

    <show-text ref="showTextRef"> </show-text>
  </div>
</template>

<script>
import {
  defineComponent,
  reactive,
  provide,
  ref,
  computed,
  inject,
  watch,
  nextTick,
  watchEffect,
} from "vue";
import { useStore } from "vuex";
import { debounce } from "@/utils";
import { useRoute } from "vue-router";
import { testTable } from "@/views/rdmanagement/components/projectScheme/options";
import { useTable } from "@/views/notice/serve/table";
import {
  insertProjectSchedule,
  getProjectScheduleList,
  deleteProjectSchedule,
} from "@/request/view/project";
import {
  ganntConfig,
  handelExpandGanntData,
  setListener,
} from "@/views/rdmanagement/components/projectScheme/gannt";
import {
  handleMouseMove,
  handleMouseUp,
  sliderPosition,
} from "@/views/rdmanagement/components/customGantt/components/serve";
import { projectLifeCycleOptions } from "@/views/rdmanagement/components/database/options";
import { getStaffListData, staffList } from "./staffUser";
import {
  DeleteOutlined,
  EditOutlined,
  PlusSquareOutlined,
} from "@ant-design/icons-vue";
import projectSchemeForm from "@/views/rdmanagement/components/projectScheme/form.vue";
import customGannt from "@/views/rdmanagement/components/customGantt/index.vue";
import sliderGannt from "@/views/rdmanagement/components/customGantt/components/slider.vue";
import showText from "@/views/rdmanagement/components/projectScheme/showText.vue";

export default defineComponent({
  components: {
    showText,
    projectSchemeForm,
    DeleteOutlined,
    EditOutlined,
    customGannt,
    PlusSquareOutlined,
    sliderGannt,
  },
  setup() {
    const route = useRoute();
    const user = useStore().state.user.user;
    const projectSchemeFormRef = ref();
    const searchInput = ref();
    const showTextRef = ref();
    const handleSearchInput = ref();
    const wbsOptions = ref([]);
    const dataMode = ref(null);
    const expandedRowKeys = ref([]);
    const isProjectLear = ref(false);
    const activeKey = inject("activeKey", null);

    provide("wbsOptions", wbsOptions);

    const {
      requestConfig,
      table,
      requestPayload,
      initPayload,
      getListData,
      searchData,
      deleteRecords,
    } = useTable();

    const ganttShow = ref(false);

    const handleUpdateGanttShow = () => {
      ganttShow.value = !ganttShow.value;

      if (ganttShow.value) {
        handelExpandGanntData(table.data, expandedRowKeys.value);
      }
    };

    const showTable = computed(() => {
      if (!searchInput.value) {
        return table.data;
      } else {
        const showList = [];
        const ite = (list) => {
          list.forEach((item) => {
            if (item.taskName.indexOf(searchInput.value) !== -1) {
              showList.push(item);
            }
            if (item.children && item.children.length > 0) {
              ite(item.children);
            }
          });
        };

        ite(table.data);
        return showList;
      }
    });

    requestConfig.pull_fn = getProjectScheduleList;
    requestConfig.delete_fn = deleteProjectSchedule;

    initPayload({
      projectLifeCycle: route.query.projectLifeCycle,
      projectLifeCycleId: route.query.projectId,
      publisher: null,
      executor: null,
      structureName: null,
      // username: null,
      // structureName: user.secondaryDepartment || user.firstLevelDepartment,
      // username: user.nickName,
    });

    const getWbs = () => {
      wbsOptions.value.length = 0;
      const ite = (list) => {
        list.forEach((item) => {
          wbsOptions.value.push({
            label: `${item.wbs} ${item.taskName}`,
            value: item.wbs,
            id: item.id,
          });
          if (item.children && item.children.length > 0) {
            ite(item.children);
          }
        });
      };
      ite(table.data);
    };

    const columns = [
      {
        title: "wbs",
        dataIndex: "wbs",
      },
      {
        title: "任务名称",
        dataIndex: "taskName",
        align: "center",
        // slots: {
        //   filterDropdown: "filterDropdown",
        // },
        // onFilter: (value, record) =>
        //   record.taskName
        //     .toString()
        //     .toLowerCase()
        //     .includes(value.toLowerCase()),
        // onFilterDropdownVisibleChange: (visible) => {
        //   if (visible) {
        //     setTimeout(() => {
        //       console.log(handleSearchInput.value);
        //       handleSearchInput.value.focus();
        //     }, 100);
        //   }
        // },
      },
      {
        title: "任务最终输出",
        align: "center",
        slots: {
          customRender: "outputResults",
        },
      },
      {
        title: "发布人",
        dataIndex: "publisher",
        align: "center",
        width: "95px",
        // slots: {
        //   filterDropdown: "filterDropdown",
        // },
        // onFilter: (value, record) =>
        //   record.publisher
        //     .toString()
        //     .toLowerCase()
        //     .includes(value.toLowerCase()),
        // onFilterDropdownVisibleChange: (visible) => {
        //   if (visible) {
        //     setTimeout(() => {
        //       console.log(handleSearchInput.value);
        //       handleSearchInput.value.focus();
        //     }, 100);
        //   }
        // },
      },
      {
        title: "执行人",
        dataIndex: "executor",
        align: "center",
        width: "95px",
        // slots: {
        //   filterDropdown: "filterDropdown",
        // },
        // onFilter: (value, record) =>
        //   record.executor
        //     .toString()
        //     .toLowerCase()
        //     .includes(value.toLowerCase()),
        // onFilterDropdownVisibleChange: (visible) => {
        //   if (visible) {
        //     setTimeout(() => {
        //       handleSearchInput.value.focus();
        //     }, 100);
        //   }
        // },
      },
      {
        title: "执行",
        align: "center",
        slots: {
          customRender: "execute",
        },

        width: "95px",
      },
      {
        title: "开始日期",
        align: "center",
        slots: {
          customRender: "startDate",
        },

        width: "110px",
      },
      {
        title: "结束日期",
        align: "center",
        slots: {
          customRender: "endDate",
        },
        width: "110px",
      },
      {
        title: "关联",
        dataIndex: "association",
        align: "center",
      },
      {
        title: "完成",
        dataIndex: "completionDegree",
        slots: {
          customRender: "completionDegree",
        },
        align: "center",

        width: "80px",
      },
      {
        title: "工作记录",
        slots: {
          customRender: "workRecords",
        },
        align: "center",
      },
      {
        title: "所需帮助",
        slots: {
          customRender: "assistanceNeeded",
        },
        align: "center",
      },
      {
        title: "操作",
        dataIndex: "action",
        align: "center",
        width: "100px",
        slots: {
          customRender: "action",
        },
      },
    ];

    const caseTitle = (type) => {
      let title = null;
      switch (type) {
        case "release":
          title = "发布";
          break;
        case "scheduled":
          title = "计划";
          break;
        case "actualRelease":
          title = "执行";
          break;
        case "insertTask":
          title = "新增任务";
          break;
        case "insertSubtask":
          title = "新增任务";
          break;
        case "updateTask":
          title = "编辑任务";
          break;
        default:
          break;
      }
      return title;
    };

    const handleUpdateRecord = (data, type) => {
      projectSchemeFormRef.value.showModal({
        title: caseTitle(type),
        data,
        type,
      });
    };

    const expand = (expanded, record) => {
      const { id, pid } = record;
      const deleteIndex = expandedRowKeys.value.findIndex((r) => r === id);
      if (expanded) {
        expandedRowKeys.value.push(id);
      } else if (deleteIndex !== -1) {
        expandedRowKeys.value.splice(deleteIndex, 1);
      }
      handelExpandGanntData(table.data, expandedRowKeys.value);
    };

    const getData = () => {
      getListData({ unPagingRequest: true }).then(() => {
        getWbs();
        setListener(table.data, expandedRowKeys.value);
        nextTick(() => {
          handelExpandGanntData(table.data, expandedRowKeys.value);
        });
      });
    };

    const setStructureSearch = () => {
      requestPayload.structureName =
        user.secondaryDepartment || user.firstLevelDepartment;
      requestPayload.username = null;
    };

    const setExamineSearch = () => {
      requestPayload.username = user.nickName;
      requestPayload.structureName = null;
    };

    const setAllData = () => {
      requestPayload.username = null;
      requestPayload.structureName = null;
    };
    /**
     * @params { type } 审批数据 部门数据
     */
    const handleUpdate = (type) => {
      if (type === "审批数据") {
        setExamineSearch();
      } else if (type === "部门数据") {
        setStructureSearch();
      } else if (type === "全部") {
        setAllData();
      }
      getData();
    };

    const handleDeleteRecord = (record) => {
      deleteRecords([record.id], {
        title: "确认删除该记录？",
      }).then(() => {
        getData();
      });
    };

    const hanndleSearch = debounce(() => {
      getData();
    }, 200);

    const state = reactive({
      searchText: "",
      searchedColumn: "",
    });

    const handleSearch = (selectedKeys, confirm, dataIndex) => {
      confirm();
      state.searchText = selectedKeys[0];
      state.searchedColumn = dataIndex;
    };

    const handleReset = (clearFilters) => {
      clearFilters();
      state.searchText = "";
    };

    const layout = reactive({
      tableWidth: 0,
      ganttWidth: 0,
    });

    const tableLayout = computed(() => {
      if (sliderPosition.tableWidth === null) {
        return "width: 48vw;";
      }
      return `width: ${sliderPosition.tableWidth}vw;`;
    });

    const ganttLayout = computed(() => {
      if (sliderPosition.gantt === null) {
        return "width: 48vw;";
      }
      return `width: ${sliderPosition.gantt}vw;`;
    });

    const updateLayout = (e) => {
      const { tableWidth, ganttWidth } = e;
      layout.ganttWidth = ganttWidth;
      layout.tableWidth = tableWidth;
    };

    const showTextDetail = (record, key, isRever) => {
      const text = record[key];
      const title = {
        workRecords: "工作记录",
        outputResults: "任务最终输出",
      };
      showTextRef.value.show(text, title[key], isRever);
    };

    watch(
      () => route.path,
      (val, oldval) => {
        // if (val === "/notice" || oldval === "/notice") {
        //   return;
        // }
        if (route.path === "/rdprojectlayout") {
          requestPayload.projectLifeCycle = route.query.projectLifeCycle;
          requestPayload.projectLifeCycleId = route.query.projectId;
          isProjectLear.value = user.nickName === route.query.projectLeader;

          provide("projectLifeCycle", requestPayload.projectLifeCycle);
          if (
            route.query.type === "link" &&
            route.query.activeKey === "项目计划"
          ) {
            requestPayload.publisher = null;
            requestPayload.executor = null;
            setExamineSearch();
            getListData({ unPagingRequest: true }).then(() => {
              getWbs();
              searchInput.value = route.query.taskName;
            });
          } else {
            searchInput.value = null;
            getData();
          }
        }
      },
      {
        immediate: true,
        deep: true,
      }
    );
    
    watch(
      () => activeKey,
      (val) => {
        if (val.value === "项目计划") {
          getData();
        }
      },
      {
        deep: true,
      }
    );

    if (staffList.value.length === 0) {
      getStaffListData();
    }

    return {
      user,
      staffList,
      ganttShow,
      handleUpdateGanttShow,
      showTextDetail,
      sliderPosition,
      handleMouseMove,
      handleMouseUp,
      tableLayout,
      ganttLayout,
      table,
      route,
      updateLayout,
      ganntConfig,
      showTextRef,
      isProjectLear,
      testTable,
      columns,
      state,
      handleSearchInput,
      handleSearch,
      handleReset,
      getData,
      showTable,
      dataMode,
      expand,
      searchInput,
      requestPayload,
      expandedRowKeys,
      projectLifeCycleOptions,
      projectSchemeFormRef,
      handleUpdateRecord,
      handleDeleteRecord,
      hanndleSearch,
      handleUpdate,
    };
  },
});
</script>

<style lang="less" >
.gantt-show-config {
  width: 20px;
}
.output-result {
  border-bottom: 1px solid #f0f0f0;
  height: 30px;
  line-height: 30px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.outupt-result-text-left {
  text-align: left;
}
.publish-pale {
  background: #d8e4bc;
}
.excutor-pale {
  background: #fde9d9;
}
.task-result {
  height: 92px;
  overflow-y: auto;
}
.special-row > td :last-child {
  border: none;
}

.table-disabled > td {
  background: #e7e7e7 !important;
}
.special-row :nth-child(3),
.special-row :nth-child(6),
.special-row :nth-child(7),
.special-row :nth-child(8),
.special-row :nth-child(11),
.special-row :nth-child(12),
.special-row :nth-child(13) {
  padding: 0;
}

.even-row > td:nth-child(1),
.even-row > td:nth-child(2),
.even-row > td:nth-child(3),
.even-row > td:nth-child(4),
.even-row > td:nth-child(5),
.even-row > td:nth-child(9) {
  background: #d8e4bc;
}

.odd-row > td:nth-child(1),
.odd-row > td:nth-child(2),
.odd-row > td:nth-child(3),
.odd-row > td:nth-child(4),
.odd-row > td:nth-child(5),
.odd-row > td:nth-child(9) {
  background: #fbfff3;
}

.even-row > td:nth-child(10),
.even-row > td:nth-child(11),
.even-row > td:nth-child(12) {
  background: #fde9d9;
}

.odd-row > td:nth-child(10),
.odd-row > td:nth-child(11),
.odd-row > td:nth-child(12) {
  background: #fffaf5;
}

.scheme-table {
  .ant-table-thead > tr > th {
    padding: 31px 16px;
  }
}

.special-row > td:nth-child(1) {
  font-weight: bold;
  font-size: 16px;
}
</style>
